/** Âm báo tin mới: hai nốt ngắn bằng WebAudio (không cần file âm thanh); lỗi/không hỗ trợ thì im lặng. */
let ctx: AudioContext | undefined;

export function playPing() {
  try {
    const AC = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AC) return;
    ctx ??= new AC();
    if (ctx.state === 'suspended') void ctx.resume();
    const t0 = ctx.currentTime;
    [880, 1175].forEach((freq, i) => {
      const osc = ctx!.createOscillator();
      const gain = ctx!.createGain();
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, t0 + i * 0.12);
      gain.gain.exponentialRampToValueAtTime(0.12, t0 + i * 0.12 + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + i * 0.12 + 0.18);
      osc.connect(gain).connect(ctx!.destination);
      osc.start(t0 + i * 0.12);
      osc.stop(t0 + i * 0.12 + 0.2);
    });
  } catch {
    // Trình duyệt chặn phát tự động hoặc không có thiết bị âm thanh.
  }
}
